import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOrderMSTeamMember } from '~/types/order/models'

const apiEntityPath = '/api/ordermsteammembers'

export async function createOrderMSTeamMember(entity: IOrderMSTeamMember) {
  const callingMn = createOrderMSTeamMember.name
  const apiPath = apiEntityPath
  return httpPost<IOrderMSTeamMember>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateOrderMSTeamMember(
  entityData: Partial<IOrderMSTeamMember>,
  id: TEntityId
) {
  const callingMn = updateOrderMSTeamMember.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialOrderMSTeamMember = Partial<IOrderMSTeamMember>
  return httpPatchMerge<TPartialOrderMSTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOrderMSTeamMember(entityData: IOrderMSTeamMember) {
  const callingMn = deleteOrderMSTeamMember.name
  const apiPath = apiEntityPath
  return httpDelete<IOrderMSTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}
